import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getProductData = (params) => {
    return AxiosService.Get(`api/cam/pc/product-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

 

  getMetaList = () => {
    return AxiosService.Get(`api/cam/pc/dropdown-all/`, {
      ...this.getHeaders(),
      // params: params,
    });
  };

  addProduct = (data, obj) => {
    return AxiosService.Post(`api/cam/pc/create-product/`, data, {
      // params: data,
      ...this.getHeaders(),
    });
  };
  
  deleteProduct = (obj) => {
    return AxiosService.Delete(`api/cam/pc/delete-product/`, obj);
  };

  approveProduct = (obj) => {
    return AxiosService.Post(`api/cam/pc/approve-product/`, obj);
  };

  updateProduct = ( obj) => {
    return AxiosService.Put(
      `api/cam/pc/update-product/`,
      obj,
      // params,
      true,
      this.getHeaders()
    );
  };
}
